import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, takeUntil } from 'rxjs';
import { CategoriesCompliance } from './models/categories-compliance.model';
import { ExecuteVisitType, EvaluatedSummaryType } from './models/execute-visit.model';
import { VisitMetaData } from './models/visit-metadata.model';
import { CriterionsService } from './services/criterions.service';
import { Utils } from 'formiojs';
import { ICriterion } from '../distribute-team-members/models/criterion';
import { FormioCustomComponent } from 'dp-formio';
import { MasarCriterionsService } from './services/masar-criterions.service';

@Component({
    selector: 'app-execute-visit-wrapper',
    templateUrl: './execute-visit-wrapper.component.html',
    // styleUrls: ['./execute-visit-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class ExecuteVisitWrapperComponent implements FormioCustomComponent<any>, OnInit, OnDestroy, OnChanges {
    @Input() required: boolean;
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;

    categoriesCompliance: CategoriesCompliance[];
    executeVisitType: ExecuteVisitType;
    evaluatedSummaryType: EvaluatedSummaryType;
    visitMetaData: VisitMetaData;
    isMistakeDisabled = false;
    responseNotesDecision = false;
    disableEntityResponse = false;
    disableAttachments = false;
    hideMistake = false;
    isReady = false;
    decisionInputs$ = this.criterionsService.decisionInputs$;

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    constructor(private criterionsService: CriterionsService,
        private masarCriterionsService: MasarCriterionsService) {
    }
    ngOnInit(): void {
        this.registerResultsListener();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.customOptions) {
            this.categoriesCompliance = this.customOptions.categoriesCompliance;
            this.criterionsService.forms.attachmentsFormKey = this.customOptions.attachmentsFormKey;
            this.executeVisitType = this.customOptions.executeVisitType;
            this.evaluatedSummaryType = this.customOptions.evaluatedSummaryType || EvaluatedSummaryType.All;
            this.isMistakeDisabled = this.customOptions.isMistakeDisabled || false;
            this.disableEntityResponse = this.customOptions.disableEntityResponse || false;
            this.disableAttachments = this.customOptions.disableAttachments || false;
            this.hideMistake = this.customOptions.hideMistake || false;
            this.visitMetaData = this.data?.visitMetaData;
            if (this.customOptions.evaluatedMetaData) {
                this.visitMetaData = Utils.evaluate(this.customOptions.evaluatedMetaData, { submission: this.data });
            }
            if (this.customOptions.responseNotesDecision) {
                this.responseNotesDecision = Utils.evaluate(this.customOptions.responseNotesDecision, { submission: this.data });
            }
            //just for test
            // this.executeVisitType = ExecuteVisitType.FinalReport;
            this.isReady = !!this.visitMetaData?.visitKey && !!this.categoriesCompliance?.length && !!this.executeVisitType;
            if (this.isReady) {
                this.registerFormioListener();
            }
        }
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

    private registerResultsListener() {
        this.sub = this.criterionsService.results$
            .subscribe(result => {
                this.value = result;
                this.valueChange.emit(this.value);
                this.afterChangeValue();
            });
    }

    private afterChangeValue() {
        if (this.customOptions && this.customOptions.afterChange)
            this.customOptions.afterChange.forEach((item) => {
                if (this.formioComponent.root.wizard) {
                    const pages = this.formioComponent.root.getFastPages({
                        all: true,
                        withoutFirstLoad: true,
                    });
                    const components = Utils.searchComponents(pages, { key: item.key });
                    components.forEach((c) => {
                        if (item.checkConditions) {
                            c.checkConditions();
                        }
                        else if (item.calculateValue) {
                            c.calculateValue(this.data);
                        } else {
                            const value = Utils.evaluate(item.value, {
                                data: this.data,
                                instance: this.formioComponent,
                            });
                            c.setValue(value);
                        }
                    });
                } else {
                    const nestedForms = Utils.searchComponents(this.formioComponent.root.components, {
                        type: 'form',
                        'component.display': 'wizard',
                    });
                    nestedForms.forEach((formComponent) => {
                        formComponent.subFormReady.then((subForm) => {
                            const pages = subForm.getFastPages({ all: true, withoutFirstLoad: true });
                            const components = Utils.searchComponents(pages, { key: item.key });
                            components.forEach((c) => {
                                if (item.checkConditions) {
                                    c.checkConditions();
                                }
                                else if (item.calculateValue) {
                                    c.calculateValue(this.data);
                                } else {
                                    const value = Utils.evaluate(item.value, {
                                        data: this.data,
                                        instance: this.formioComponent,
                                    });
                                    c.setValue(value);
                                }
                            });
                        });
                    });

                    const components = Utils.searchComponents(this.formioComponent.root.components, {
                        key: item.key,
                    });
                    components.forEach((c) => {
                        if (item.checkConditions) {
                            c.checkConditions();
                        }
                        else if (item.calculateValue) {
                            c.calculateValue(this.data);
                        } else {
                            const value = Utils.evaluate(item.value, {
                                data: this.data,
                                instance: this.formioComponent,
                            });
                            c.setValue(value);
                        }
                    });
                }
            });
    }

    private registerFormioListener() {
        this.formioComponent?.off('updateData');
        this.formioComponent?.on('updateData', (data) => {
            this.masarCriterionsService.updatedCriterionKey$.next(data);
        });
    }
}
